/**
 * @package DMV Advisors
 * @version 2.0.0
 */

$(document).ready(function() {
  $('#dmv-advisors-form').formValidation({
    framework: 'bootstrap',
    icon: {
      valid: 'icon icon-success',
      invalid: 'icon icon-danger',
      validating: 'fa fa-refresh',
    },
    fields: {
      path: {
        validators: {
          notEmpty: {
            message: 'You must select a question category',
          },
        },
      },
      user_input: {
        validators: {
          notEmpty: {
            message: 'Some kind of question is expected',
          },
        },
      },
      question_state: {
        validators: {
          notEmpty: {
            message: 'Please select a state',
          },
        },
      },
      first_name: {
        validators: {
          notEmpty: {
            message: 'Your first name is required',
          },
        },
      },
      last_name: {
        validators: {
          notEmpty: {
            message: 'Your last name is required',
          },
        },
      },
      email: {
        validators: {
          notEmpty: {
            message: 'Your email is required to contact you back with answers',
          },
          emailAddress: {
            message: 'The email must be a valid email address',
          },
        },
      },
    },
  });
});



// WEBPACK FOOTER //
// ./scripts/plugins/dmv-advisors-forms/index.js